
import { jsPDF } from "jspdf";
import { TechneColors } from "../types";

/**
 * Add glossary section
 */
export const addGlossary = (doc: jsPDF, { pageWidth, colors }: { pageWidth: number, colors?: TechneColors }): void => {
  const glossaryY = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 20 : 150;
  
  doc.setFontSize(14);
  doc.text("AI Governance Glossary", 15, glossaryY);
  
  doc.setDrawColor(200, 200, 200);
  doc.line(15, glossaryY + 5, pageWidth - 15, glossaryY + 5);
  
  const glossaryTerms = [
    {
      term: "AI (Artificial Intelligence)",
      definition: "Technology that enables machines to perform tasks typically requiring human intelligence."
    },
    {
      term: "Machine Learning",
      definition: "A subset of AI that involves training algorithms to learn from data."
    },
    {
      term: "Fiduciary Duty",
      definition: "A legal obligation of board members to act in the best interests of the organization and its shareholders."
    },
    {
      term: "Bias",
      definition: "Systematic error that can result in unfair or skewed outcomes in AI models."
    },
    {
      term: "Explainability",
      definition: "The extent to which the inner workings of an AI system can be understood by humans."
    },
    {
      term: "NIST AI Risk Management Framework",
      definition: "A framework outlining the steps to govern, map, measure, and manage AI risks."
    }
  ];
  
  let termY = glossaryY + 15;
  glossaryTerms.forEach((item) => {
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text(item.term, 15, termY);
    
    doc.setFont(undefined, 'normal');
    const defLines = doc.splitTextToSize(item.definition, pageWidth - 30);
    doc.text(defLines, 15, termY + 7);
    
    termY += 7 + (defLines.length * 5) + 8;
  });
};
